import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Plan, PlanState } from "src/types/plan.types";

const initialState: PlanState = {
  createPlan: {
    loading: false,
    data: null,
    error: null,
  },
  editPlan: {
    loading: false,
    data: null,
    error: null,
  },
  plansList: {
    loading: false,
    data: null,
    error: null,
  },
  planDetails: {
    loading: false,
    data: null,
    error: null,
  },
  publicPlansList: {
    loading: false,
    data: null,
    error: null,
  },
};

const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    // create plan
    createPlanRequest: (state, action: PayloadAction<any>) => {
      state.createPlan.loading = true;
      state.createPlan.data = null;
      state.createPlan.error = null;
    },
    createPlanSuccess: (state, action: PayloadAction<any>) => {
      state.createPlan.loading = false;
      state.createPlan.data = action.payload;
      state.createPlan.error = null;
    },
    createPlanError: (state, action: PayloadAction<string>) => {
      state.createPlan.loading = false;
      state.createPlan.data = null;
      state.createPlan.error = action.payload;
    },
    resetCreatePlan: (state) => {
      state.createPlan.loading = false;
      state.createPlan.data = null;
      state.createPlan.error = null;
    },

    // edit plan
    editPlanRequest: (state, action: PayloadAction<any>) => {
      state.editPlan.loading = true;
      state.editPlan.data = null;
      state.editPlan.error = null;
    },
    editPlanSuccess: (state, action: PayloadAction<any>) => {
      state.editPlan.loading = false;
      state.editPlan.data = action.payload;
      state.editPlan.error = null;
    },
    editPlanError: (state, action: PayloadAction<string>) => {
      state.editPlan.loading = false;
      state.editPlan.data = null;
      state.editPlan.error = action.payload;
    },
    resetEditPlan: (state) => {
      state.editPlan.loading = false;
      state.editPlan.data = null;
      state.editPlan.error = null;
    },

    // get plan list actions
    getPlanListRequest: (
      state,
      action: PayloadAction<{ page: number; limit: number }>
    ) => {
      state.plansList.loading = true;
      state.plansList.data = null;
      state.plansList.error = null;
    },
    getPlanListSuccess: (state, action: PayloadAction<any>) => {
      state.plansList.loading = false;
      state.plansList.data = action.payload;
      state.plansList.error = null;
    },
    getPlanListError: (state, action: PayloadAction<string>) => {
      state.plansList.loading = false;
      state.plansList.data = null;
      state.plansList.error = action.payload;
    },

    // get plan details actions
    getPlanDetailsRequest: (state, action: PayloadAction<string>) => {
      state.planDetails.loading = true;
      state.planDetails.data = null;
      state.planDetails.error = null;
    },
    getPlanDetailsSuccess: (state, action: PayloadAction<any>) => {
      state.planDetails.loading = false;
      state.planDetails.data = action.payload?.data || null;
      state.planDetails.error = null;
    },
    getPlanDetailsError: (state, action: PayloadAction<string>) => {
      state.planDetails.loading = false;
      state.planDetails.data = null;
      state.planDetails.error = action.payload;
    },
    resetPlanDetails: (state) => {
      state.planDetails.loading = false;
      state.planDetails.data = null;
      state.planDetails.error = null;
    },

    // get public plan list actions (marketing pricing page)
    getPublicPlanListRequest: (state) => {
      state.publicPlansList.loading = true;
      state.publicPlansList.data = null;
      state.publicPlansList.error = null;
    },
    getPublicPlanListSuccess: (state, action: PayloadAction<any>) => {
      state.publicPlansList.loading = false;
      state.publicPlansList.data = action.payload?.data || [];
      state.publicPlansList.error = null;
    },
    getPublicPlanListError: (state, action: PayloadAction<string>) => {
      state.publicPlansList.loading = false;
      state.publicPlansList.data = null;
      state.publicPlansList.error = action.payload;
    },
  },
});

export const {
  // create plan actions
  createPlanRequest,
  createPlanSuccess,
  createPlanError,
  resetCreatePlan,

  // edit plan actions
  editPlanRequest,
  editPlanSuccess,
  editPlanError,
  resetEditPlan,

  // get plan list actions
  getPlanListRequest,
  getPlanListSuccess,
  getPlanListError,

  // get plan details actions
  getPlanDetailsRequest,
  getPlanDetailsSuccess,
  getPlanDetailsError,
  resetPlanDetails,

  // get public plan list actions
  getPublicPlanListRequest,
  getPublicPlanListSuccess,
  getPublicPlanListError,
} = planSlice.actions;
export default planSlice.reducer;
